export enum Brands {
    VW = 'VW',
    AUDI = 'Audi',
    DUCATI = 'Ducati',
    Volkswagen = 'Volkswagen',
    Bently = 'Bently',
    Lamborghini = 'Lamborghini',
}
